interface Props {
  message: string;
}

export function AssistantError({ message }: Props) {
  return (
    <div
      role="alert"
      className="mx-3 my-2 rounded-xl border border-[#9C3B2E]/40 bg-[#9C3B2E]/15 px-3 py-2 text-[12px] text-[#E08F82]"
    >
      Something went wrong: {message}
    </div>
  );
}
